import { useState, useCallback } from "react";
import { DtSnackbar } from "../components/ui/alert";
import { AlertColor } from "@mui/material";

export function useSnackbar() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<AlertColor>("info");

  const showSnackbar = useCallback((msg: string, sev: AlertColor = "info") => {
    setMessage(msg);
    setSeverity(sev);
    setOpen(true);
  }, []);

  const snackbar = (
    <DtSnackbar
      open={open}
      message={message}
      severity={severity}
      onClose={() => setOpen(false)
      }
    />
  );

  return { showSnackbar, snackbar };
}